/* AM26 2026-08-27 — selectorul de culoare din bara sticky compactă (brațul B).
   Spec: docs/cro-instrumentare-sticky-atc.md

   CE FACE: pune un buton invizibil peste poza din bară; la apăsare deschide un
   panou cu variantele (poză + nume + bifă pe cea curentă); la alegere schimbă
   varianta prin `select`-ul NATIV al temei, ca tema să-și facă singură treaba
   (preț, imagine, disponibilitate, formularul de adăugare).

   DE CE PRIN SELECTUL TEMEI, nu direct pe formular: tema ascultă `change` pe
   `select[name="product_id_sticky"]` și sincronizează restul paginii. Dacă am
   scrie noi `input[name=id]`, am ocoli acea sincronizare și am rupe exact ce
   face bara utilă. Ascunderea selectului e VIZUALĂ (clip), nu `display:none`,
   tocmai ca să rămână funcțional.

   DELEGARE + re-atașare: tema ÎNLOCUIEȘTE noduri la schimbarea variantei
   (bug-ul de SKU din 21.08.2026), deci nimic nu se leagă o singură dată de un
   nod anume. */
(function () {
  if (window.__amBaraCompacta) return;
  window.__amBaraCompacta = true;

  // MOBILE-ONLY, ca și CSS-ul. Fără asta, pe desktop atașam un declanșator de
  // swatch peste o poză pe care CSS-ul nostru n-o mai stilizează — exact tipul
  // de nepotrivire care produce un element invizibil dar apăsabil.
  // Pragul e 760px, identic cu al temei (Codex, 27.08): un prag diferit ar lăsa
  // o bandă în care JS-ul e activ iar CSS-ul nu.
  var MOBIL = '(max-width: 760px)';
  function peMobil() {
    try { return window.matchMedia(MOBIL).matches; } catch (e) { return true; }
  }

  var ID_BARA = 'sticky-add-to-cart';
  var panou = null;
  var panouInvechit = false;

  function bara() { return document.getElementById(ID_BARA); }
  function selectul() {
    var b = bara();
    return b ? b.querySelector('select[name="product_id_sticky"]') : null;
  }

  // Variantele: din selectul temei (sursa de adevăr pentru ce e disponibil),
  // îmbogățite cu imaginea fiecărei variante din obiectul de produs al temei.
  function variante() {
    var sel = selectul();
    if (!sel) return [];
    var poze = {};
    try {
      var d = window.amProdusVariante || null;
      if (d) d.forEach(function (v) { poze[String(v.id)] = v.img; });
    } catch (e) {}
    return [].map.call(sel.options, function (o) {
      return {
        id: o.value,
        nume: (o.text || '').trim(),
        selectat: o.selected,
        indisponibil: o.disabled,
        img: poze[String(o.value)] || null
      };
    });
  }

  function inchide() {
    if (panou) panou.setAttribute('data-deschis', '0');
    var t = document.querySelector('.am-swatch-trigger');
    if (t) t.setAttribute('aria-expanded', 'false');
  }

  function alege(id) {
    var sel = selectul();
    if (!sel) return;
    sel.value = id;
    // `change` cu bubbling — tema ascultă pe nod sau delegat, acoperim ambele.
    sel.dispatchEvent(new Event('change', { bubbles: true }));
    inchide();
    try {
      (window.dataLayer = window.dataLayer || []).push({
        event: 'am_sticky_variant_change',
        am_exp_sticky: window.amExpSticky || 'nealocat'
      });
    } catch (e) {}
  }

  function construiestePanou() {
    var vs = variante();
    if (vs.length < 2) return null;      // o singură variantă: poza rămâne informativă
    if (!panou) {
      panou = document.createElement('div');
      panou.className = 'am-swatch-panel';
      panou.setAttribute('role', 'dialog');
      panou.setAttribute('aria-label', 'Alege culoarea');
      document.body.appendChild(panou);
    }
    var ul = document.createElement('ul');
    vs.forEach(function (v) {
      var li = document.createElement('li');
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'am-swatch-optiune';
      b.setAttribute('role', 'radio');
      b.setAttribute('aria-checked', v.selectat ? 'true' : 'false');
      if (v.indisponibil) b.setAttribute('data-indisponibil', '1');
      b.dataset.id = v.id;
      if (v.img) {
        var im = document.createElement('img');
        im.src = v.img; im.alt = ''; im.loading = 'lazy';
        b.appendChild(im);
      }
      var n = document.createElement('span');
      n.className = 'nume'; n.textContent = v.nume;
      b.appendChild(n);
      var bif = document.createElement('span');
      bif.className = 'bifa'; bif.textContent = '✓'; bif.setAttribute('aria-hidden', 'true');
      b.appendChild(bif);
      li.appendChild(b); ul.appendChild(li);
    });
    panou.innerHTML = '';
    panou.appendChild(ul);
    return panou;
  }

  // Poza din bară e `loading="lazy"` iar bara e ascunsă până la scroll, deci
  // browserul NU o descarcă până când nu se dezvăluie. Rezultat măsurat pe DEV:
  // `naturalWidth 0` cât timp bara e ascunsă => în primele momente după apariție
  // swatch-ul e un pătrat gol, exact în fereastra în care omul decide să cumpere.
  // O cerem devreme, DOAR pe brațul B și doar pe mobil (140x140, ~10 KB).
  function incarcaPozaDevreme(fig) {
    var img = fig && fig.querySelector('img');
    if (!img || img.dataset.amEager === '1') return;
    img.dataset.amEager = '1';
    try { img.loading = 'eager'; } catch (e) {}
    if (!img.complete || img.naturalWidth === 0) {
      var src = img.currentSrc || img.src;
      if (src) { var pre = new Image(); pre.src = src; }
    }
  }

  function ataseazaDeclansator() {
    if (!peMobil()) return;
    var b = bara();
    if (!b) return;
    var fig = b.querySelector('figure');
    if (!fig) return;
    incarcaPozaDevreme(fig);
    if (fig.querySelector('.am-swatch-trigger')) return;
    if (variante().length < 2) return;

    var t = document.createElement('button');
    t.type = 'button';
    t.className = 'am-swatch-trigger';
    t.setAttribute('aria-haspopup', 'true');
    t.setAttribute('aria-expanded', 'false');
    t.setAttribute('aria-label', 'Alege culoarea');
    fig.appendChild(t);
  }

  // Delegare pe document, în capture — imună la re-randările temei.
  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target.closest('.am-swatch-trigger') : null;
    if (t) {
      e.preventDefault(); e.stopPropagation();
      // Reconstruim la DESCHIDERE, nu din observer — vezi nota despre buclă.
      var p = construiestePanou();
      if (!p) return;
      panouInvechit = false;
      var deschis = p.getAttribute('data-deschis') === '1';
      p.setAttribute('data-deschis', deschis ? '0' : '1');
      t.setAttribute('aria-expanded', deschis ? 'false' : 'true');
      if (!deschis) {
        var prim = p.querySelector('.am-swatch-optiune[aria-checked="true"]') ||
                   p.querySelector('.am-swatch-optiune');
        if (prim) prim.focus();
      }
      return;
    }
    var opt = e.target.closest ? e.target.closest('.am-swatch-optiune') : null;
    if (opt) {
      e.preventDefault();
      if (opt.getAttribute('data-indisponibil') === '1') return;
      alege(opt.dataset.id);
      return;
    }
    // click în afară → închide
    if (panou && panou.getAttribute('data-deschis') === '1' &&
        !e.target.closest('.am-swatch-panel')) inchide();
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && panou && panou.getAttribute('data-deschis') === '1') {
      inchide();
      var t = document.querySelector('.am-swatch-trigger');
      if (t) t.focus();
    }
  });

  // ── Re-atașare la re-randările temei ───────────────────────────────────────
  // BUCLĂ REALĂ EVITATĂ AICI (semnalată de Codex la revizuire, 27.08):
  // versiunea anterioară observa `document.documentElement` cu `subtree:true` ȘI
  // apela `construiestePanou()` din handler. `construiestePanou()` face
  // `panou.innerHTML = ''` + `appendChild` — adică exact mutații `childList` pe
  // care observerul le urmărea. Cu panoul deschis, prima reconstrucție se
  // auto-declanșa la infinit.
  //
  // Două schimbări, fiecare suficientă singură; le păstrez pe amândouă:
  //   1. observ DOAR secțiunea barei, nu tot documentul — panoul stă în <body>,
  //      deci reconstrucția lui nu mai e observată deloc;
  //   2. handlerul NU mai reconstruiește panoul; doar marchează că e învechit,
  //      iar reconstrucția se face la următoarea deschidere.
  //
  // (Ipoteza mea inițială — că bucla venea din `ridicaRoot()` scriind
  // `style.zIndex` — era GREȘITĂ: un observer `childList` nu vede mutații de
  // atribut. Am notat-o ca să nu se re-propună.)
  function porNesteObserver() {
    var sect = document.getElementById('shopify-section-sticky-add-to-cart') ||
               (bara() && bara().parentElement);
    if (!sect) return false;
    new MutationObserver(function () {
      ataseazaDeclansator();
      if (panou && panou.getAttribute('data-deschis') === '1') panouInvechit = true;
    }).observe(sect, { childList: true, subtree: true });
    return true;
  }
  if (!porNesteObserver()) {
    // Secțiunea încă nu există: o așteptăm o singură dată, fără subtree pe tot
    // documentul mai mult decât e nevoie.
    var asteptare = new MutationObserver(function () {
      if (porNesteObserver()) asteptare.disconnect();
    });
    asteptare.observe(document.body || document.documentElement, { childList: true, subtree: true });
  }


  // ── Ridicarea peste widgeturile flotante: MUTATĂ ÎN CSS ────────────────────
  // A FOST AICI, ÎN JS, ȘI A PROVOCAT UN CRASH DE PAGINĂ (semnalat de Tudor,
  // 27.08): `ridicaRoot()` scria `root.style.zIndex`, iar `MutationObserver`-ul
  // de mai jos observă `subtree: true` pe tot documentul — o scriere de stil E o
  // mutație, deci se retriggera singur. Buclă infinită de reflow; Chrome cerea
  // reîncărcarea paginii la redimensionare.
  //
  // Regula e acum pur CSS (`am-cro-bara-compacta.css`), condiționată de aceleași
  // clase pe care tema le pune oricum pe <html> (`product-scrolled` / `scrolled`).
  // Zero JavaScript, deci zero buclă. Lecția: nu scrie stiluri dintr-un handler
  // observat de un MutationObserver pe subtree.

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ataseazaDeclansator);
  } else {
    ataseazaDeclansator();
  }

  // ── Trecerea desktop -> mobil, fără reîncărcare ─────────────────────────────
  // CSS-ul e pe `@media`, deci se reevaluează singur la redimensionare; JS-ul NU.
  // Măsurat (27.08): pornind pe desktop și redimensionând la 390px, bara lua
  // corect forma compactă de 71px, dar rămânea FĂRĂ declanșator de culoare —
  // `trigger: false`. Adică exact varianta pe care Tudor o cere, ciuntită.
  // Se întâmplă la rotirea telefonului, la deschiderea tastaturii pe unele
  // browsere și pe desktopul cu fereastra trasă îngust.
  //
  // `matchMedia(...).addEventListener('change')` se declanșează o singură dată
  // per traversare de prag, deci nu e un ascultător de `resize` costisitor.
  try {
    var mq = window.matchMedia(MOBIL);
    var laSchimbare = function () {
      if (mq.matches) { ataseazaDeclansator(); return; }
      // Trecere mobil -> desktop: închidem lista ȘI scoatem declanșatorul.
      // Măsurat că rămânea în DOM după redimensionare. E inert acolo (CSS-ul
      // nostru nu se aplică peste 760px, iar tema ascunde `figure`), dar un nod
      // invizibil și apăsabil e fix categoria de bug pe care o vânez azi —
      // mai bine nu exista decât să depindă de două reguli ca să fie inofensiv.
      inchide();
      var b = bara();
      var t = b && b.querySelector('.am-swatch-trigger');
      if (t && t.parentNode) t.parentNode.removeChild(t);
    };
    if (mq.addEventListener) mq.addEventListener('change', laSchimbare);
    else if (mq.addListener) mq.addListener(laSchimbare);   // Safari vechi
  } catch (e) { /* fără matchMedia rămâne comportamentul de la încărcare */ }
})();
